import { api } from './http'

export interface CompanionItem {
  id: number
  name: string
  city?: string
  price?: number
  rating?: number
  review_count?: number
  avatar?: string
  specialties?: string
  pb_full?: string
  pb_half?: string
}

export interface Paginated<T> {
  total: number
  page: number
  page_size: number
  items: T[]
}

export const companionsApi = {
  list: (page = 1, pageSize = 20, params?: { q?: string; city?: string }) => {
    const query = new URLSearchParams({ page: String(page), page_size: String(pageSize) })
    if (params?.q) query.set('q', params.q)
    if (params?.city) query.set('city', params.city)
    return api.get<Paginated<CompanionItem>>(`/companions?${query.toString()}`)
  },
  get: (id: number) => api.get<CompanionItem>(`/companions/${id}`),
}

